
let inject = [
  '$scope',
  'QuotationsService',
  '$state',
  '$rootScope',
  'SharedService',
  '$timeout',
  'ngAuthSettings',
  'SessionService',
  'NgTableParams',
  '$uibModal',
  '$stateParams',
  'ServiceOrdersService'
];
class QuotationsController{
  constructor ($scope,
               QuotationsService,
               $state,
               $rootScope,
               SharedService,
               $timeout,
               ngAuthSettings,
               SessionService,
               NgTableParams,
               $uibModal,
               $stateParams,
               ServiceOrdersService) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.SessionService = SessionService;
    this.ngAuthSettings = ngAuthSettings;
    this.NgTableParams = NgTableParams;
    // this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.QuotationsService = QuotationsService;
    this.ServiceOrdersService = ServiceOrdersService;
    this.$uibModal = $uibModal;
    this.SharedService = SharedService;

    this.quotationsList = null;
    this.stateQuotations = {};
    this.ngTableConfigQuotations = null;
    this.ngTableColsQuotations = null;

    this.quotationDetail = null;
    this.stateQuotationDetail = {};
    this.ngTableConfigQuotationDetail = null;
    this.ngTableColsQuotationDetail = null;
    this.currentQuote = {};

    this.wachingDetailQuotation = false;

    this.payment = {};
    this.payment.recaudo = 0;
    this.payment.recaudo_total = 0;

    this.orderServiceId = this.$stateParams.orderServiceId || null;
  }

  $onInit(){
    this.getQuotationsHead();
  }

  getQuotationsHead(){

    this.stateQuotations.loading = true;
    this.wachingDetailQuotation = false;
    this.$timeout(()=>{
      if(this.quotationsList && this.quotationsList.length > 0){
        this.stateQuotations.loading = false;
        this.stateQuotations.loaded = true;
      }else{
        //this.shCtrl.globals.currentUser.thirdDocumentNumber
        let promiseQuotations = (this.orderServiceId ? this.ServiceOrdersService.getServiceOrdersDetail(this.orderServiceId) : this.QuotationsService.getQuotationsHead());
        promiseQuotations.then((response) => {
          this.stateQuotations.loading = false;
          this.stateQuotations.loaded = true;
          if(response.length){
            if(this.orderServiceId){
              response.splice((response.length - 1), 1);
            }

            this.quotationsList = response;
            this.quotationsList.forEach((value, index)=>{
              value.valor_doc = parseInt(value.total);
              value.valor_pendiente = parseInt(value.total);
              value.valor_pagar_hoy = 0;
              value.valor_pagar_hoy_before = 0;
              this.payment.recaudo += value.valor_pendiente;
              value.type = "Cotización";
            })
            //this.quotationsList = cabeceraData;
            //console.log("cotizaciones cabecera " + JSON.stringify(response));
            this.initNgTableQuotations();
          }

        }).catch((reason) => {
          this.stateQuotations.loading = false;
          this.stateQuotations.loaded = true;
          this.stateQuotations.error = true;
        });
      }

    }, 1000);
  }

  changeValor(row){
    let valorQuotation = parseInt(row.valor_pagar_hoy.replace(/,/g, ''));
    if(valorQuotation > row.valor_pendiente){
      row.valor_pagar_hoy = row.valor_pendiente;
      valorQuotation = row.valor_pendiente;
    }
    this.payment.recaudo_total -= row.valor_pagar_hoy_before;
    this.payment.recaudo_total += valorQuotation;

    row.valor_pagar_hoy_before = valorQuotation;
  }

  activateQuotation(row){
    if(row.activate){
      row.valor_pagar_hoy = row.valor_pendiente;
      row.valor_pagar_hoy_before = row.valor_pendiente;
      this.payment.recaudo_total += row.valor_pendiente;

    }else{
      this.payment.recaudo_total -= row.valor_pagar_hoy_before;
      row.valor_pagar_hoy = 0;
      row.valor_pagar_hoy_before = 0;
    }

  }

  initNgTableQuotations() {
    /**
     * name:                           "NCN-000024"
     * type:                             "Lorem Ipsum"
     * fecha_cotizacion:                 "2016-09-14"
     * validez_cotizacion:               "2016-09-14"
     * assigned_user_name:               "Lorem Ipsum"
     * valor_saldo:                      "0.0000"
     * valor_pendiente:                  "0.0000"
     * valor_pagar_hoy:                  "0.0000"
     * total:                            "0.0000"
     */
    this.ngTableColsQuotations = [
      {
        field: "name",
        title: "No. Doc.",
        sortable: "name",
        filter: { "name": "text" },
        show: true
      },
      {
        field: "fecha_cotizacion",
        title: "F. Elaboración",
        sortable: "fecha_cotizacion",
        filter: { "fecha_cotizacion": "date" },
        show: true
      },
      {
        field: "validez_cotizacion",
        title: "F. Vencimiento",
        sortable: "validez_cotizacion",
        filter: { "validez_cotizacion": "date" },
        show: true
      },
      {
        field: "assigned_user_name",
        title: "Vendedor",
        sortable: "assigned_user_name",
        filter: { "assigned_user_name": "text" },
        show: true
      },
      {
        field: "subtotal",
        title: "Subtotal",
        sortable: "subtotal",
        filter: { "subtotal": "text" },
        show: true
      },
      {
        field: "impuestos",
        title: "Impuestos",
        sortable: "impuestos",
        filter: { "impuestos": "text" },
        show: true
      },
      {
        field: "valor_doc",
        title: "Vr. Doc.",
        sortable: "valor_doc",
        filter: { "valor_doc": "text" },
        show: true
      },
      {
        field: "valor_pagar_hoy",
        title: "Vr. a pagar hoy",
        show: true
      },
      {
        field: "selection",
        title: "",
        show: true
      },
      {
        field: "actions",
        title: "",
        show: true
      }
    ];

    let initialParams = {
      count: 20,
      sorting: { fecha_cotizacion: "desc" }
    };

    let initialSettings = {
      counts: [5, 10, 20],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.quotationsList
    };

    this.ngTableConfigQuotations = new this.NgTableParams(initialParams, initialSettings);
  }

  getQuotationDetail(document){
    this.currentQuote.number = document.name;
    this.currentQuote.value = document.valor_doc;

    this.wachingDetailQuotation = true;
    this.stateQuotationDetail.loading = true;
    this.$timeout(()=>{
      this.QuotationsService.getQuotationsDetail(document.name).then((response) => {
        this.stateQuotationDetail.loading = false;
        this.stateQuotationDetail.loaded = true;
        this.quotationDetail = response;
        this.quotationDetail.forEach((value, index) => {
          value.vr_unit = parseInt(value.vr_unit);
          value.cantidad = parseInt(value.cantidad);
          value.vr_total = parseInt(value.vr_total);
          value.porcentaje_descuento = parseInt(value.porcentaje_descuento);
          value.descuento_moneda = parseInt(value.descuento_moneda) || (value.vr_unit * (value.porcentaje_descuento / 100));
          value.impuestos = parseInt(value.impuestos);
        });

        //console.log("cotizaciones cabecera " + JSON.stringify(response));
        this.initNgTableQuotationDetail();
      }).catch((reason) => {
        this.stateQuotationDetail.loading = false;
        this.stateQuotationDetail.loaded = true;
        this.stateQuotationDetail.error = true;
      });
    }, 1000);
  }

  initNgTableQuotationDetail() {
    /**
     * nombre:                     "Estufa verde a gas"
     * referencia:                 "981323"
     * cantidad:                   "5"
     * unidad_medida:              "BOLSA"
     * vr_unit:                    "0.0000"
     * descuento:                  "0.0000"
     * porcentaje_descuento:       "5%"
     * impuestos:                  "0.0000"
     * vr_total:                   "0.0000"
     */

    this.ngTableColsQuotationDetail = [
      {
        field: "descripcion_item",
        title: "Nombre",
        sortable: "descripcion_item",
        filter: { "descripcion_item": "text" },
        show: true
      },
      {
        field: "referencia",
        title: "Ref.",
        sortable: "referencia",
        filter: { "referencia": "text" },
        show: true
      },
      {
        field: "cantidad",
        title: "Cant.",
        sortable: "cantidad",
        filter: { "cantidad": "text" },
        show: true
      },
      {
        field: "unidad_medida",
        title: "U.M.",
        sortable: "unidad_medida",
        filter: { "unidad_medida": "text" },
        show: true
      },
      {
        field: "vr_unit",
        title: "Vr. Unit.",
        sortable: "vr_unit",
        filter: { "vr_unit": "text" },
        show: true
      },
      {
        field: "descuento_moneda",
        title: "Vr. Desc",
        sortable: "descuento_moneda",
        filter: { "descuento_moneda": "text" },
        show: true
      },
      {
        field: "porcentaje_descuento",
        title: "% Desc",
        sortable: "porcentaje_descuento",
        filter: { "porcentaje_descuento": "text" },
        show: true
      },
      {
        field: "impuestos",
        title: "Impuestos",
        sortable: "impuestos",
        filter: { "impuestos": "text" },
        show: true
      },
      {
        field: "vr_total",
        title: "Total",
        sortable: "vr_total",
        filter: { "vr_total": "text" },
        show: true
      }
    ];

    let initialParams = {
      count: 20
    };

    let initialSettings = {
      counts: [5, 10, 20],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.quotationDetail
    };

    this.ngTableConfigQuotationDetail = new this.NgTableParams(initialParams, initialSettings);
  }
}

QuotationsController.$inject = inject;

export default QuotationsController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/payments-advances/quotations/quotations.controller.js
 **/